export default __webpack_public_path__ + "static/media/EM1050.34I-27024_-16404_0.f7421d6b.jpg";